
const MIN_PREFIX_LENGTH = 2;


const MIN_FUZZY_LENGTH = 4;

const NUMERIC = /^\d+$/;

// Below this RediSearch has nothing to work with: it rejects 1-char prefixes,
// so a lone character can only be an exact-term match, which finds nothing and
// wipes the results already on screen.
export const MIN_QUERY_LENGTH = 2;

const EMPTY = { query: "", terms: [], rawQuery: "", suggestTerm: false };


function escapeString(str) {
  return str.replace(/['""]/g, "'").replace(/[^\s\w\d]/g, "\\$&");
}

/**
 * @param {string} search 
 * @returns {{query: string, terms: string[], rawQuery: string, suggestTerm: string|false}}
 */
export function parseSearchString(search) {
  const raw = (search || "").trim();
  if (raw.length < MIN_QUERY_LENGTH) return EMPTY;


  const exactMatch = raw.match(/^["'](.*)["']$/);
  if (exactMatch) {
    const quoted = exactMatch[1].trim().split(/\s+/).filter(Boolean);
    if (quoted.length === 0) return EMPTY;
    return {
      query: quoted.map(escapeString).join(" "),
      terms: quoted,
      rawQuery: quoted.join(" "),
      suggestTerm: false,
    };
  }

  const words = raw.split(/\s+/).filter(Boolean);


  const hasAnchor = words.some((word) => word.length >= MIN_PREFIX_LENGTH);

  const query = words
    .map((word) => {
      const escaped = escapeString(word);


      if (word.length < MIN_PREFIX_LENGTH) {
        return hasAnchor ? `~${escaped}` : escaped;
      }

      const variants = [escaped, `${escaped}*`];


      if (!NUMERIC.test(word) && word.length >= MIN_FUZZY_LENGTH) {
        variants.push(`%${escaped}%`);
      }

      return `(${variants.join("|")})`;
    })
    .join(" ");


  const suggestTerm =
    words.length < 3 && words[0].length > 3 ? words[0] : false;

  return { query, terms: words, rawQuery: raw, suggestTerm };
}

export default parseSearchString;
